/**
 * Running order of every scene that exists. Disabled modules simply drop out; nothing else
 * needs to change. Keep the MINT family together, then step out to the wider ecosystem.
 */
export const RUNNING_ORDER: readonly string[] = [
  // Why Moderta exists
  'opening',
  'problem',
  'approach',
  // The flagship: MINT and its specialisations
  'mint-core',
  'mint-intelligence',
  'mint-specialisation',
  'mint-it',
  'mint-travel',
  'mint-business',
  'mint-directions',
  // The wider ecosystem
  'ecosystem',
  // Moderta AI — Research Space replaces the former Orchestrator slot in place; Moderta Native follows immediately.
  'research-space',
  'research-approval',
  'native',
  'carbon-proof',
  'carbon-verify',
  // ClimateViewPoint (formerly Sustain Insight) keeps its slot.
  'climateviewpoint',
  'etrust',
  // Why it adds up
  'shared-dna',
  'technology',
  'process',
  'future',
  'closing',
];
